import { useTranslation } from 'react-i18next';

import OrderedList, {
	OrderedListItem,
} from '../../../../kakapo-ui-kit/components/lists/OrderedList';

export default function FeedbackRespondInstructions() {
	const { t } = useTranslation();

	return (
		<OrderedList title={t('feedback.list.howToGiveFeedback')}>
			<OrderedListItem>{t('feedback.list.howToGiveFeedbackStep1')}</OrderedListItem>
			<OrderedListItem>{t('feedback.list.howToGiveFeedbackStep2')}</OrderedListItem>
			<OrderedListItem>{t('feedback.list.howToGiveFeedbackStep3')}</OrderedListItem>
		</OrderedList>
	);
}
